import React from 'react';
import styled from 'styled-components';

const Styled = {
    Container: styled.div<{ sizeGrid?: string, quantity?: number}>`
        display: grid;
        margin-left: 80px;
        margin-right: 80px;
        grid-template-columns: ${props => props.sizeGrid ? props.sizeGrid : `repeat(${props.quantity}, 1fr)`};
        gap: 20px;
       
        

        @media screen and (max-width: 1280px){
            margin-left: 0px;
            margin-right: 0px;
        }
    `,
};

interface GridColumnsProps {
    quantity?: number;
    size?: string;
    children: React.ReactNode;
    styles?: React.CSSProperties;
    className?: string;
    gridReverse?: boolean;
}

const GridColumns = ({ quantity, size, children, styles, className, gridReverse = false }: GridColumnsProps) => {
    // Convert children to an array so we can reverse the order when gridReverse is true
    const childArray = React.Children.toArray(children);
    const renderedChildren = gridReverse ? childArray.reverse() : childArray;

    return (
        <Styled.Container quantity={quantity} sizeGrid={size} style={styles} className={className}>
            {renderedChildren}
        </Styled.Container>
    );
};


export default GridColumns